import type { Translations } from '../types';

export const ja: Translations = {
    common: {
        save: '保存',
        cancel: 'キャンセル',
        delete: '削除',
        edit: '編集',
        add: '追加',
        loading: '読み込み中...',
        error: 'エラー',
        success: '成功',
        confirm: '確認',
        yes: 'はい',
        no: 'いいえ',
        search: '検索',
        noResults: '結果なし',
        refresh: '更新',
        logout: 'ログアウト',
        settings: '設定',
        download: 'Download',
    },
    nav: {
        chat: 'チャット',
        gallery: 'ギャラリー',
        settings: '設定',
        admin: '管理者',
        users: 'ユーザー',
        models: 'モデル',
    },
    auth: {
        login: 'ログイン',
        register: '登録',
        username: 'ユーザー名',
        password: 'パスワード',
        currentPassword: '現在のパスワード',
        newPassword: '新しいパスワード',
        confirmPassword: 'パスワード確認',
        loginButton: 'ログイン',
        registerButton: '登録',
        loggingIn: 'ログイン中...',
        invalidCredentials: 'ユーザー名またはパスワードが正しくありません',
        changePassword: 'パスワード変更',
        changingPassword: '変更中...',
        passwordChanged: 'パスワードが変更されました。他のデバイスはログアウトされます。',
        invalidateAllSessions: '全デバイスログアウト',
        allSessionsInvalidated: 'すべてのセッションが無効化されました。再度ログインしてください。',
    },
    chat: {
        newChat: '新規チャット',
        sendMessage: '送信',
        typeMessage: 'メッセージを入力...',
        noChats: 'チャットがありません',
        startNewChat: '新しいチャットを始めましょう',
        deleteChat: 'チャット削除',
        deleteChatConfirm: 'このチャットを削除しますか？',
        deleteMessages: 'メッセージ削除',
        deleteMessageConfirm: 'このメッセージを削除しますか？',
        exportChat: 'エクスポート',
        importChat: 'インポート',
        selectModel: 'モデル選択',
        thinking: '考え中...',
    },
    gallery: {
        title: 'ギャラリー',
        description: '生成された画像と動画の管理',
        upload: 'アップロード',
        dragDrop: 'ファイルをドラッグ＆ドロップ',
        delete: '削除',
        move: '移動',
        sync: '同期',
        noFiles: 'ファイルがありません',
        syncComplete: '同期完了',
        uploadComplete: 'アップロード完了',
        deleteConfirm: '選択したファイルを削除しますか？',
        newFolder: '新規フォルダ',
        path: 'パス',
        filename: 'ファイル名',
        no_metadata: 'メタデータがありません',
        model: 'モデル',
        seed: 'シード',
        size: 'サイズ',
        sampler: 'サンプラー',
        prompt: 'プロンプト',
        negative_prompt: 'ネガティブプロンプト',
        ai_analyze: 'AIチャット分析',
        mode_image: '画像のみ',
        mode_prompt: 'プロンプトのみ',
        mode_both: '画像＋プロンプト',
        apply_settings: '生成設定を適用',
    },
    settings: {
        title: '設定',
        apiKey: 'Google APIキー',
        apiKeyDesc: 'Gemini APIを使用するためのAPIキー',
        apiKeyPlaceholder: 'AIzaで始まるAPIキー',
        apiKeySaved: 'APIキーが保存されました。',
        apiKeyRemoved: 'APIキーが削除されました。',
        removeApiKey: 'APIキー削除',
        r2Config: 'R2ストレージ設定',
        r2ConfigDesc: 'Cloudflare R2ストレージ設定',
        r2Configured: 'R2が設定されています',
        r2SaveSuccess: 'R2設定が保存されました。',
        r2ChangeHint: 'R2設定を変更するには、以下のフォームを再度入力してください。',
        autoSave: 'メディア自動保存',
        autoSaveDesc: '生成された画像/動画をR2に自動保存',
        chatBackup: 'チャットバックアップ',
        exportAll: '全てエクスポート',
        importAll: '全てインポート',
        backupDesc: '全てのチャットとメッセージをJSONファイルでバックアップまたは復元します。',
        backupSuccess: 'バックアップが完了しました。',
        backupFailed: 'バックアップに失敗しました。',
        importSuccess: 'インポートが完了しました。',
        importFailed: 'インポートに失敗しました。',
        security: 'セキュリティ',
        securityDesc: 'パスワード変更とセッション管理',
        passwordChangeHint: 'パスワードを変更すると、他のデバイスのセッションが自動的にログアウトされます。',
        sessionLogoutHint: '他の全てのデバイスからログアウトします。',
        systemPrompts: 'システムプロンプト',
        addPrompt: '追加',
        promptTitle: 'タイトル',
        promptContent: '内容',
        deletePromptConfirm: 'このプロンプトを削除しますか？',
        clearCacheConfirm: 'ローカルキャッシュを削除しますか？',
        clearCache: 'キャッシュ削除',
        clearCacheDesc: 'ローカルキャッシュを削除しますか？UI状態がリセットされます。',
        cacheClearedRefresh: 'キャッシュが削除されました。ページを更新します。',
    },
    admin: {
        users: {
            title: 'ユーザー管理',
            description: 'ユーザーアカウントの作成と管理',
            addUser: 'ユーザー追加',
            username: 'ユーザー名',
            password: 'パスワード',
            role: '役割',
            admin: '管理者',
            user: 'ユーザー',
            createdAt: '作成日',
            actions: '操作',
            noUsers: '登録されたユーザーがいません',
            deleteConfirm: 'このユーザーを削除しますか？',
            createFailed: 'ユーザーの作成に失敗しました。',
            cannotDeleteSelf: '自分自身は削除できません。',
            cannotChangeOwnRole: '自分自身の役割は変更できません。',
            passwordMinLength: 'パスワードは8文字以上である必要があります。',
            passwordChanged: 'パスワードが変更されました。',
            resetPassword: 'パスワードリセット',
            newPassword: '新しいパスワード（8文字以上）',
            enterNewPassword: 'の新しいパスワードを入力してください。',
        },
        models: {
            title: 'モデル設定',
            description: 'ユーザーに提供するAIモデルの管理',
            fetchFromGoogle: 'Googleから取得',
            fetchModels: 'モデル取得',
            noModels: '登録されたモデルがありません',
            noModelsDesc: '「Googleから取得」ボタンをクリックして利用可能なモデルを読み込んでください。',
            active: '有効',
            inactive: '無効',
            modelsFetched: 'モデル取得完了',
            fetchFailed: 'モデルの取得に失敗しました。APIキーを確認してください。',
            deleteConfirm: 'このモデルを削除しますか？',
            helpTitle: 'ヘルプ',
            helpItems: [
                '有効なモデルのみがユーザーに表示されます。',
                '「Googleから取得」は設定ページに保存されたAPIキーを使用します。',
                'モデルリストはGoogle Gemini APIから提供されます。',
            ],
        },
    },
    time: {
        justNow: 'たった今',
        minutesAgo: '分前',
        hoursAgo: '時間前',
        daysAgo: '日前',
    },
    errors: {
        networkError: 'ネットワークエラーが発生しました',
        unauthorized: '認証が必要です',
        serverError: 'サーバーエラーが発生しました',
        notFound: '見つかりません',
        rateLimited: 'リクエストが多すぎます。しばらくしてからお試しください。',
    },
};
